import React from "react";
import {Link} from "react-router-dom";

class MightyESim extends React.Component {
  go() {
    //window.location.href = 'https://mightyesim.com/collections/destinations';
    /*let a= document.createElement('a');
    a.target= '_blank';
    a.href= 'https://mightyesim.com/collections/destinations';
    a.click();*/
  }
  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (

        <section className="section app-seciton" style={{background: "url(../images/mighty-esim.jpg)", padding: "145px 0"}} onClick={this.go}>

          <div className="container">
            <div className="row">

              <div className="col-lg-8">
                <div className="text-left">
                  {/*<div style={{ clear: "both", height: "360px" }} />*/}
                  <div style={{ clear: "both", height: "110px" }} />
                  <h4 className="SansSerif bold600"><strong className="point-orange2">eSIM:</strong> TICKET TO <strong className="point-orange2">GLOBAL CONNECTIVITY</strong></h4>
                  <div style={{ clear: "both", height: "10px" }} />
                  <h1 className="Title bold600"><strong className="point-orange2">DISCOVER</strong> THE WORLD</h1>
                  <div style={{ clear: "both", height: "60px" }} />
                  <div className="col-lg-12 no-padding">
                    <small>Unlock Your Ticket to Global Connectivity with eSIM - Stay Connected, Anywhere, Anytime!</small>
                  </div>
                  <div style={{ clear: "both", height: "50px" }} />

                  <div className="app-btn">
                    <a className="btn btn-orange2" href="https://mightyesim.com/collections/destinations" target="_blank">YOUR DESTINATIONS</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
              </div>

            </div>
          </div>
        </section>
    );
  }
}

export default MightyESim;



// WEBPACK FOOTER //
// ./src/layout/MightyESim.js